import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import classNames from "classnames"
import { useMemo } from "react"
import "./styles.scss"

/**
 * @typedef {object} HeaderWrapperProps
 * @property {any} [title]
 * @property {any} [children]
 * @property {any} [onClickIcon]
 * @property {any} [icon]
 * @property {any} [className]
 * @property {any} [customTitle]
 * @property {any} [classNameIcon]
 */

/**
 * @param {HeaderWrapperProps} props
 */
const HeaderWrapper = ({
  title,
  children,
  onClickIcon,
  icon,
  className = "pt-4",
  customTitle,
  classNameIcon,
}: $TSMigrationFixMe) => {
  const onRenderCustomTitle = useMemo(() => customTitle?.(), [customTitle])

  return (
    <header
      className={classNames([
        "header-wrapper d-flex d-flex align-items-center justify-content-between",
        className,
      ])}
    >
      <div className='header-wrapper__title d-flex align-items-center'>
        {icon && (
          <span
            onClick={onClickIcon}
            className={classNameIcon}
          >
            <FontAwesomeIcon
              icon={["fal", icon]}
              className='icon-plus tw-cursor-pointer'
            />
          </span>
        )}
        <div className='tw-text-xl tw-font-normal tw-text-text'>
          {title ? <span>{title}</span> : onRenderCustomTitle}
        </div>
      </div>
      {children}
    </header>
  )
}

export default HeaderWrapper
